// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyAJUYUtzBuwIek_YTolcqmQRJj2i4sLDHw",
    authDomain: "takht-jamshid.firebaseapp.com",
    projectId: "takht-jamshid",
    storageBucket: "takht-jamshid.appspot.com",
    messagingSenderId: "148720973380",
    appId: "1:148720973380:web:55f9b15d97327c1a2aae11",
    measurementId: "G-L9Q7RWERWF"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);

export default firebaseApp